<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>{{ getTitle }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-show="!isStudentView"
      ></v-text-field>
      <v-spacer></v-spacer>
      <template>
        <v-btn dark outline class="mb-2" v-show="isStudentView" @click="back">
          Back
        </v-btn>
      </template>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="students"
      :loading="progressBar"
      :pagination.sync="pagination"
      :search="search"
      item-key="Id"
      class="elevation-1"
      select-all
      v-show="!isStudentView"
    >
      <template v-slot:progress>
        <v-progress-linear
          slot="progress"
          color="primary"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td
            v-for="(value, index) in tableDisplayFields"
            :key="index"
            class="text-xs-center"
            @click="getStudentDetails(props.item.Id)"
          >
            {{ props.item[value] }}
          </td>
        </tr>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
      <template v-slot:no-data>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
          v-show="progressBar == false || students.length == 0"
        >
          No Results
        </v-alert>
      </template>
    </v-data-table>

    <v-card v-show="isStudentView">
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-progress-linear
            slot="progress"
            color="primary"
            height="4"
            indeterminate
            v-show="progressBar"
          ></v-progress-linear>
          <v-flex xs12>
            <v-card-text>
              <v-list
                dense
                v-for="(value,
                propertyName,
                index) in studentDisplayFieldsMappings"
                :key="index"
              >
                <v-list-tile>
                  <v-list-tile-content>
                    <v-container grid-list-md text-xs-center>
                      <v-layout row wrap>
                        <v-flex xs4>
                          <div class="subheading xs4 text-xs-left">
                            {{ value }}:
                          </div>
                        </v-flex>
                        <v-flex xs6>
                          <div class="body-2 xs6 text-xs-left">
                            {{ model[propertyName] }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-flex>
        </v-layout>
        <template>
          <v-btn color="primary" dark class="mb-2" @click="approve"
            >Approve</v-btn
          >
          <v-btn color="primary" dark class="mb-2" @click="reject"
            >Reject</v-btn
          >
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import dbStore from "../db/dbStore";

export default {
  name: "Approval",
  components: {},
  data: function() {
    return {
      id: "",
      progressBar: false,
      search: "",
      pagination: {
        sortBy: "name"
      },
      isStudentView: false,
      title: "",
      selected: [],
      students: [],
      headers: [
        {
          text: "First Name",
          align: "center",
          sortable: true,
          value: "FirstName"
        },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Email", value: "Email", align: "center" },
        { text: "Phone", value: "Phone", align: "center" },
        { text: "Status", value: "Status", align: "center" }
      ],
      tableDisplayFields: ["FirstName", "LastName", "Email", "Phone", "Status"],
      studentDisplayFieldsMappings: {
        Batch: "Batch",
        DateOfEnrolment: "Date Of Enrolment",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Status: "Status",
        attendance_percent: "Attendance Percentage"
      },
      model: {},
      viewModel: {}
    };
  },
  created() {
    this.getStudents();
  },
  computed: {
    getTitle() {
      if (this.isStudentView) {
        return "Student Details";
      } else {
        return "Approvals";
      }
    }
  },
  methods: {
    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("students");
      this.model = await dbStore.getItem(this.id);
      this.viewModel = this.model;
      dbStore.setCollectionName("batches");
      this.Batch = await dbStore.getItem(this.model.Batch);
      this.viewModel.Batch = this.Batch.Name;
      this.viewModel.attendance_percent =
        Math.round(this.viewModel.attendance_percent * 100) / 100;
      this.progressBar = false;
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    getStudentDetails(Id) {
      //console.log(Id)
      this.id = Id;
      this.getData();
      this.isStudentView = true;
    },

    async getStudents() {
      try {
        this.progressBar = true;
        var filter = {
          Field: "Status",
          Operation: "==",
          Value: "Pending Approval"
        };
        dbStore.setCollectionName("students");
        this.students = await dbStore.getFilteredItems(filter);
        this.progressBar = false;
      } catch (err) {
        //throw.error(err);
        console.log("Error getting data : " + err);
      }
    },

    back() {
      this.isStudentView = false;
    },

    async updateStudentProperty(id, json) {
      let response;
      try {
        //console.log(this.formModel)
        dbStore.setCollectionName("students");
        response = await dbStore.updateItemProperty(id, json);
        if (response.isStateChanged) {
          this.getStudents();
          this.isStudentView = false;
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error updating student : " + err);
      }
    },
    //#TODO change to enums
    approve() {
      var json = { Status: "Approved" };
      this.updateStudentProperty(this.id, json);
    },

    reject() {
      var json = { Status: "Rejected" };
      this.updateStudentProperty(this.id, json);
    }
  }
};
</script>
